/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Authcallbackexpired2Inputs */

const en_authcallbackexpired2 = /** @type {(inputs: Authcallbackexpired2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your diagnostic link expired. Re-run the funnel to get a fresh one.`)
};

const pt_authcallbackexpired2 = /** @type {(inputs: Authcallbackexpired2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O link do diagnóstico expirou. Refaça o diagnóstico para obter um novo.`)
};

/**
* | output |
* | --- |
* | "Your diagnostic link expired. Re-run the funnel to get a fresh one." |
*
* @param {Authcallbackexpired2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const authcallbackexpired2 = /** @type {((inputs?: Authcallbackexpired2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Authcallbackexpired2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_authcallbackexpired2(inputs)
	return pt_authcallbackexpired2(inputs)
});
export { authcallbackexpired2 as "authCallbackExpired" }